import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { PeopleInvolvedListComponent } from './people-involved-list/people-involved-list.component'

export const peopleInvolvedRoutes: Route[] = [
  {
    path: 'people-involveds',
    component: PeopleInvolvedListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'people-involveds/:id/edit',
    redirectTo: 'people-involveds/:id',
    pathMatch: 'full'
  },
  {
    path: 'people-involveds/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'PeopleInvolved',
        nameSingular: 'People Involved',
        namePlural: 'People Involved',
        path: 'people-involveds',
        slug: 'taxonomies/people-involveds',
        title: 'People Involved'
      }),
      permission: 'readTaxonomies'
    }
  }
]
